import { useDispatch } from "react-redux";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import styles from "./Manual.module.scss";

const id = "firstFunction5";
const idNext = "firstFunction6";
const idPrev = "firstFunction4";

const next = `
functions:
  - function: Duel
    parameters:
      - parameter: Protagonist
        choices:
          - choice: Peter
          - choice: Edmund
          - choice: Susan
      - parameter: Antagonist
        choices:
          - choice: witch
          - choice: ogre
          - choice: cyclops
          - choice: goblin
      - parameter: Weapon
        choices:
          - choice: sword
          - choice: axe
          - choice: dagger
          - choice: bow
      - parameter: Location
        choices:
          - choice: forest
          - choice: castle
          - choice: swamp
`;

const prev = `
functions:
  - function: Duel
    parameters:
      - parameter: Protagonist
      - parameter: Antagonist
      - parameter: Weapon
      - parameter: Location
`;

function ManualFirstFunction5({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      <div className={`${styles["foreground"]} ${styles["foreground-ff5"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              As you can see, now that we’ve populated the parameter with choices, it is no longer
              marked with the red error mark. Let’s repeat the process for other parameters and
              ensure they all have the correct choices. Here are the choices i’d like you to add for
              each of the parameters:
            </p>
            <table>
              <tr>
                <th>Antagonist</th>
                <th>Weapon</th>
                <th>Location</th>
              </tr>
              <tr>
                <td>witch</td>
                <td>sword</td>
                <td>forest</td>
              </tr>
              <tr>
                <td>ogre</td>
                <td>axe</td>
                <td>castle</td>
              </tr>
              <tr>
                <td>cyclops</td>
                <td>dagger</td>
                <td>swamp</td>
              </tr>
              <tr>
                <td>goblin</td>
                <td>bow</td>
                <td></td>
              </tr>
            </table>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateFirstFunction5 = (root, tutorial, setTutorial) => {
  if (tutorial === id) {
    let { res: resFun } = tutorialUtils.validateSingleFunction(root, "Duel");

    if (!resFun) {
      return false;
    }

    let { res: resA } = tutorialUtils.validateParameterChoices(root, false, false, "Protagonist", [
      "Peter",
      "Edmund",
      "Susan",
    ]);

    if (!resA) {
      return false;
    }

    let { res: resB } = tutorialUtils.validateParameterChoices(root, false, false, "Antagonist", [
      "witch",
      "ogre",
      "cyclops",
      "goblin",
    ]);

    if (!resB) {
      return false;
    }

    let { res: resC } = tutorialUtils.validateParameterChoices(root, false, false, "Weapon", [
      "sword",
      "axe",
      "dagger",
      "bow",
    ]);

    if (!resC) {
      return false;
    }

    let { res: resD } = tutorialUtils.validateParameterChoices(root, false, false, "Location", [
      "forest",
      "castle",
      "swamp",
    ]);

    if (!resD) {
      return false;
    }

    setTutorial(idNext);

    return true;
  }

  return false;
};

export default ManualFirstFunction5;
